module.exports = __webpack_public_path__ + "img/empty-sommelier.ea66b64.svg";